<template>
  <div class="only-header-layout">
    <Header />

    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header/Header.vue'

  export default {
    components: {
      Header
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    padding-top: $header-height;
    min-height: 100%;
    height: 100%;
  }
</style>
